import React, { HTMLAttributes } from 'react';

const VisibilityOn = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="2.83 5.33 18.33 12.5"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.333c-4.167 0-7.725 2.592-9.167 6.25 1.442 3.659 5 6.25 9.167 6.25 4.166 0 7.725-2.591 9.166-6.25-1.441-3.658-5-6.25-9.166-6.25zm0 10.417a4.168 4.168 0 0 1-4.167-4.167 4.168 4.168 0 0 1 8.334 0c0 2.3-1.867 4.167-4.167 4.167zm0-6.667a2.497 2.497 0 0 0-2.5 2.5c0 1.384 1.117 2.5 2.5 2.5s2.5-1.116 2.5-2.5c0-1.383-1.117-2.5-2.5-2.5z"
      fill="#1D1D1D"
    />
  </svg>
);

export default VisibilityOn;
